// Session élève expirée ou fermée sur une autre tablette : l'API répond 401.
// Au lieu d'afficher « HTTP error! status: 401 », on renvoie vers la connexion
// avec un retour sur la page en cours.

export const MESSAGE_SESSION_EXPIREE = "Ta session a expiré, reconnecte-toi."

const ORIGINE_TEMOIN = "https://x.invalid"

// N'accepte qu'un chemin interne (« /assistant?x=1 »), jamais « //site » ni une URL absolue.
// Les navigateurs suppriment tabulations et sauts de ligne : « /\t/site » deviendrait « //site ».
// On refuse donc tout caractère de contrôle et tout antislash, puis on vérifie l'origine par construction.
// « /.//site » se normalise en « //site » : on refuse ce chemin normalisé et on ne renvoie que la forme normalisée.
export function cheminRetourSur(chemin: string | null | undefined): string | null {
  if (!chemin || !chemin.startsWith("/") || chemin.startsWith("//")) return null
  if (/[\u0000-\u001f\u007f\\]/.test(chemin)) return null
  let url: URL
  try {
    url = new URL(chemin, ORIGINE_TEMOIN)
  } catch {
    return null
  }
  if (url.origin !== ORIGINE_TEMOIN) return null
  if (url.pathname.startsWith("//")) return null
  if (chemin.startsWith("/auth/") || url.pathname.startsWith("/auth/")) return null
  return url.pathname + url.search + url.hash
}

export function urlConnexionAvecRetour(cheminCourant: string): string {
  const retour = cheminRetourSur(cheminCourant)
  return retour ? `/auth/login?redirect=${encodeURIComponent(retour)}` : "/auth/login"
}

// Renvoie true si la réponse était un 401 et que la redirection est lancée.
export function gererSessionExpiree(response: Pick<Response, "status">): boolean {
  if (response.status !== 401) return false
  if (typeof window !== "undefined") {
    const { pathname, search } = window.location
    alert(MESSAGE_SESSION_EXPIREE)
    window.location.assign(urlConnexionAvecRetour(pathname + search))
  }
  return true
}
